import React, { FC, useState, useEffect, memo } from "../../../lib/teact/teact";
import MyTextInput from "../ui/myTextInput";

type OwnProps = {
    mien: 'MB' | 'MT' | 'MN'
    hanMuc: any,
    loaiCuocId: string,
    onDataChange: (e:React.ChangeEvent<HTMLInputElement>) =>void;
}

const HanMucToanBoItem: FC<OwnProps> = ({
    mien,
    hanMuc,
    loaiCuocId,
    onDataChange,
}) => {
    const key = ``
    const renderEl = []
    if (mien == "MT") {
        if (loaiCuocId == "DaX") {
            for (let dai of hanMuc.daiMtDaCheo) {
                const key = `${loaiCuocId}:${dai}`
                const item = hanMuc.hanMucMT[key]
                const id = `${mien}:${loaiCuocId}:${dai}`
                if (item) {
                    renderEl.push(<MyTextInput label={dai} id={id}
                        value={item.nhanMax}
                        onChange={onDataChange}></MyTextInput>)
                }
            }
        } else {
            for (let dai of hanMuc.daiMt) {
                const key = `${loaiCuocId}:${dai}`
                const item = hanMuc.hanMucMT[key]
                const id = `${mien}:${loaiCuocId}:${dai}`
                if (item) {
                    renderEl.push(<MyTextInput label={dai} id={id}
                        value={item.nhanMax}
                        onChange={onDataChange}></MyTextInput>)
                }
            }
        }
    } else if (mien == "MN") {
        if (loaiCuocId == "DaX") {
            for (let dai of hanMuc.daiMnDaCheo) {
                const key = `${loaiCuocId}:${dai}`
                const item = hanMuc.hanMucMN[key]
                const id = `${mien}:${loaiCuocId}:${dai}`
                if (item) {
                    renderEl.push(<MyTextInput label={dai} id={id}
                        value={item.nhanMax}
                        onChange={onDataChange}></MyTextInput>)
                }
            }
        } else {
            for (let dai of hanMuc.daiMn) {
                const key = `${loaiCuocId}:${dai}`
                const item = hanMuc.hanMucMN[key]
                const id = `${mien}:${loaiCuocId}:${dai}`
                if (item) {
                    renderEl.push(<MyTextInput label={dai} id={id}
                        value={item.nhanMax}
                        onChange={onDataChange}></MyTextInput>)
                }
            }
        }
    } else if (mien == "MB") {
        const dai = "HN"
        const key = `${loaiCuocId}:${dai}`
        const item = hanMuc.hanMucMB[key]
        const id = `${mien}:${loaiCuocId}:${dai}`
        if (item) {
            renderEl.push(<MyTextInput label={dai} id={id}
                value={item.nhanMax}
                onChange={onDataChange}></MyTextInput>)
        }
    }
    return <div className=" gia-thuong-item">
        <div className=" gia-thuong-item-header">{loaiCuocId}</div>
        <div className=" item-container">

            {renderEl}
        </div>
    </div>
}
export default memo(HanMucToanBoItem)